(() => {
  if (window.__laMisetoPinMixController) return;

  const quantities = {};

  const cleanQuantity = (value) =>
    Math.max(0, parseInt(value, 10) || 0);

  const replaceValue = (text, key, value) =>
    String(text || '').replace(key, String(value));

  const getInputs = (root) => [
    ...root.querySelectorAll(
      '.lm-pin-mix__quantity input[data-variant-id]'
    )
  ];

  const rememberQuantity = (input) => {
    quantities[input.dataset.variantId] =
      cleanQuantity(input.value);
  };

  const restoreQuantities = (root) => {
    getInputs(root).forEach((input) => {
      const variantId = input.dataset.variantId;

      if (
        Object.prototype.hasOwnProperty.call(
          quantities,
          variantId
        )
      ) {
        input.value = quantities[variantId];
      }
    });
  };

  const updateRoot = (root) => {
    if (!root) return;

    const inputs = getInputs(root);
    const message = root.querySelector(
      '.lm-pin-mix__message'
    );
    const selected = root.querySelector(
      '.lm-pin-mix__selected'
    );
    const progressBar = root.querySelector(
      '.lm-pin-mix__progress span'
    );
    const addButton = root.querySelector(
      '.lm-pin-mix__add'
    );

    if (
      !message ||
      !selected ||
      !progressBar ||
      !addButton
    ) {
      return;
    }

    const tier1 = Number(root.dataset.tier1);
    const tier2 = Number(root.dataset.tier2);

    const total = inputs.reduce(
      (sum, input) =>
        sum + cleanQuantity(input.value),
      0
    );

    let statusText = root.dataset.choose;
    let percentage = 0;

    if (total > 0 && total < tier1) {
      statusText = replaceValue(
        root.dataset.more1,
        '[count]',
        tier1 - total
      );

      statusText = replaceValue(
        statusText,
        '[price]',
        root.dataset.tier1Price
      );

      percentage = (total / tier1) * 100;
    } else if (
      total >= tier1 &&
      tier2 > 0 &&
      total < tier2
    ) {
      statusText =
        root.dataset.active1 +
        ' ' +
        replaceValue(
          root.dataset.more2,
          '[count]',
          tier2 - total
        );

      percentage = (total / tier2) * 100;
    } else if (tier2 > 0 && total >= tier2) {
      statusText = root.dataset.active2;
      percentage = 100;
    } else if (total >= tier1) {
      statusText = root.dataset.active1;
      percentage = 100;
    }

    message.textContent = statusText;

    selected.textContent = replaceValue(
      root.dataset.selected,
      '[count]',
      total
    );

    progressBar.style.width =
      Math.min(100, percentage) + '%';

    addButton.disabled = total === 0;

    inputs.forEach((input) => {
      const card = input.closest(
        '.lm-pin-mix__card'
      );

      card?.classList.toggle(
        'has-quantity',
        cleanQuantity(input.value) > 0
      );
    });
  };

  const initRoot = (root) => {
    restoreQuantities(root);
    updateRoot(root);
  };

  const initAll = () => {
    document
      .querySelectorAll('.lm-pin-mix')
      .forEach(initRoot);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(
      '.lm-pin-mix__minus, ' +
      '.lm-pin-mix__plus, ' +
      '.lm-pin-mix__add'
    );

    if (!button) return;

    const root = button.closest('.lm-pin-mix');
    if (!root) return;

    if (
      button.classList.contains(
        'lm-pin-mix__minus'
      ) ||
      button.classList.contains(
        'lm-pin-mix__plus'
      )
    ) {
      const input = button
        .closest('.lm-pin-mix__quantity')
        ?.querySelector(
          'input[data-variant-id]'
        );

      if (!input || input.disabled) return;

      const current = cleanQuantity(
        input.value
      );

      input.value = button.classList.contains(
        'lm-pin-mix__minus'
      )
        ? Math.max(0, current - 1)
        : current + 1;

      rememberQuantity(input);
      updateRoot(root);
      return;
    }

    const inputs = getInputs(root);

    const items = inputs
      .map((input) => ({
        id: Number(input.dataset.variantId),
        quantity: cleanQuantity(input.value)
      }))
      .filter((item) => item.quantity > 0);

    if (!items.length) return;

    const message = root.querySelector(
      '.lm-pin-mix__message'
    );

    button.disabled = true;
    button.textContent = root.dataset.busy;

    try {
      const shopRoot =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        shopRoot + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        }
      );

      if (!response.ok) {
        throw new Error('Cart error');
      }

      if (!response.ok) {
  throw new Error('Cart error');
}

// Haal de actuele winkelwagenlade op
const miniCart = document.querySelector('#mini-cart');

if (miniCart) {
  const cartResponse = await fetch(
    miniCart.dataset.url || '?section_id=mini-cart',
    {
      headers: {
        Accept: 'text/html'
      }
    }
  );

  if (!cartResponse.ok) {
    throw new Error('Cart drawer error');
  }

  const cartHtml = await cartResponse.text();
  const cartDocument = new DOMParser().parseFromString(
    cartHtml,
    'text/html'
  );

  const freshCart = cartDocument.querySelector(
    '#shopify-section-mini-cart'
  );

  if (freshCart) {
    miniCart.innerHTML = freshCart.innerHTML;
  }
}

// Zet de aantallen terug naar nul
root
  .querySelectorAll(
    '.lm-pin-mix__quantity input[data-variant-id]'
  )
  .forEach((input) => {
    input.value = 0;
    rememberQuantity(input);
  });

updateRoot(root);
button.textContent = root.dataset.cart;

// Open de vernieuwde winkelwagenlade
const cartToggle = document.querySelector(
  'cart-drawer summary'
);

if (cartToggle) {
  cartToggle.click();
} else {
  window.location.href = shopRoot + 'cart';
}
    } catch (error) {
      if (message) {
        message.textContent =
          root.dataset.error;
      }

      button.textContent =
        root.dataset.cart;
      button.disabled = false;
    }
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest(
      '.lm-pin-mix__quantity ' +
      'input[data-variant-id]'
    );

    if (!input) return;

    input.value = cleanQuantity(input.value);
    rememberQuantity(input);
    updateRoot(input.closest('.lm-pin-mix'));
  });

  let initScheduled = false;

  const scheduleInit = () => {
    if (initScheduled) return;

    initScheduled = true;

    requestAnimationFrame(() => {
      initScheduled = false;
      initAll();
    });
  };

  const observer = new MutationObserver(
    (mutations) => {
      const pinMixAdded = mutations.some(
        (mutation) =>
          [...mutation.addedNodes].some(
            (node) =>
              node.nodeType === 1 &&
              (
                node.matches?.('.lm-pin-mix') ||
                node.querySelector?.(
                  '.lm-pin-mix'
                )
              )
          )
      );

      if (pinMixAdded) scheduleInit();
    }
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.__laMisetoPinMixController = {
    init: initAll
  };

  initAll();
})();